import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API, timeout: 180000 });

export async function apiGenerate(subject) {
  const { data } = await client.post(`/generate`, { subject });
  return data;
}

export async function apiDiagram(concept) {
  const { data } = await client.post(`/diagram`, { concept });
  return data;
}

export async function apiChat(message, contextTerm, history) {
  const { data } = await client.post(`/chat`, {
    message,
    context_term: contextTerm || null,
    history: history || [],
  });
  return data.reply;
}

export async function apiListHistory(kind) {
  const url = kind ? `/history?kind=${kind}` : `/history`;
  const { data } = await client.get(url);
  return data;
}

export async function apiGetHistory(id) {
  const { data } = await client.get(`/history/${id}`);
  return data;
}

export async function apiDeleteHistory(id) {
  const { data } = await client.delete(`/history/${id}`);
  return data;
}
